import './slider.scss';

import * as React from 'react';
import SliderItem from '../../components/slider-item/slider-item';
import Flipping from '../flipping/flipping';
import FlackityDots from '../flickity-dots/flickity-dots';

import {DirectionValue} from '../../const';

interface Props {
  sliderWrapperStyle: {};
  sliderListStyle: {};
  onSliderMouseSwipes: (evt: React.MouseEvent<HTMLUListElement, MouseEvent>) => void;
  onSliderTouchStart: (evt: React.TouchEvent<HTMLUListElement>) => void;
  onSliderTouchEnd: (evt: React.TouchEvent<HTMLUListElement>) => void;
  refSlider: (instance: HTMLUListElement) => void;
  renderingSlides: Array<React.ReactNode>;
  refItem: (element: HTMLLIElement) => void;
  slideItemWidth: {};
  slideMargin: number;
  isDisabled: boolean;
  onBtnClick: (value: DirectionValue) => void;
  allSlides: Array<string>;
  centerElementIndex: number;
  onRadioClick: (value: number) => void;
  isFlipping: boolean;
  isFlicktyDots: boolean;
}

const Slider = (props: Props) => {

  const {
    sliderWrapperStyle,
    sliderListStyle,
    onSliderMouseSwipes,
    onSliderTouchStart,
    onSliderTouchEnd,
    refSlider,
    renderingSlides,
    refItem,
    slideItemWidth,
    slideMargin,
    isDisabled,
    onBtnClick,
    allSlides,
    centerElementIndex,
    onRadioClick,
    isFlipping,
    isFlicktyDots,
  } = props;

  return (
    <article className="slider">
      <h2 className="visually-hidden">Slider</h2>

      <div className="slider__wrapper" style={sliderWrapperStyle}>
        <ul className="slider__list" style={sliderListStyle}
          onMouseDown={onSliderMouseSwipes}
          onTouchStart={onSliderTouchStart}
          onTouchEnd={onSliderTouchEnd}
          ref={refSlider}
        >
          {renderingSlides.map((slide, index) => {
            return (
              <SliderItem key={index} refItem={refItem}
                styles={
                  {
                    ...slideItemWidth,
                    marginRight: `${slideMargin}px`,
                    marginLeft: `${slideMargin}px`
                  }
                }
              >
                {slide}
              </SliderItem>
            );
          })}
        </ul>
      </div>

      {
        isFlipping
        && <Flipping
          onBtnClick={onBtnClick}
          isDisabled={isDisabled}
        ></Flipping>
      }

      {
        isFlicktyDots
        && <FlackityDots
          dots={allSlides}
          centerElementIndex={centerElementIndex}
          onDotClick={onRadioClick}
        ></FlackityDots>
      }

    </article>
  );
};

export default Slider;
